export type Deferred = {
  promise: Promise<void>;
  resolve(): void;
};

export function createDeferred(): Deferred {
  let resolve: () => void = () => undefined;
  const promise = new Promise<void>((res) => (resolve = res));

  return { promise, resolve };
}
